import { PeopleFilterFields } from 'src/app/people/models/peopleFilterFields';
import { FilterOperatorType } from '../components/odata-filter/models/filter-operator-type';
import {
  FilterGroup,
  ODataFilter,
  ODataFilterValues,
  ODataSubFilter,
} from '../components/odata-filter/models/odata-filter';
import { FilterOperator, OPERATORS } from '../components/odata-filter/models/operators';
import { SearchValueType } from '../components/odata-filter/models/search-value-type';
import { ODataFilterBuilder } from './odata-filter-builder';

export class PersonTeamSummaryFilterModel implements ODataFilter {
  targetFieldId = '';
  filterGroup = FilterGroup.SystemFields;
  subFilter = new ODataSubFilter();
  constructor(
    public targetField: string,
    public displayName: string,
    public childFieldName: string,
    public valueType: SearchValueType,
    public values?: any[] | ODataFilterValues[],
    public secondFilter?: any
  ) {}
  buildFilter(searchValue: any, filterOperator: FilterOperator) {
    let operatorTypes = OPERATORS[this.valueType];
    if (
      operatorTypes.operators.findIndex(
        (x) => x.displayOperator == filterOperator.displayOperator
      ) == -1
    ) {
      throw new Error('Invalid Operation');
    }
    if (this.valueType != SearchValueType.Number) {
      throw new Error('Invalid Operation');
    }
    searchValue =
      filterOperator.displayOperator == FilterOperatorType.isEmpty ||
      filterOperator.displayOperator == FilterOperatorType.isNotEmpty
        ? 0
        : searchValue;

    if (filterOperator.actualOperator == FilterOperatorType.eq && searchValue == 0) {
      return {
        or: [
          ODataFilterBuilder.buildSimpleFilter(this.targetField, null),
          {
            [this.targetField]: ODataFilterBuilder.buildNumberFilter(
              this.childFieldName,
              searchValue
            ),
          },
        ],
      };
    }

    if (filterOperator.actualOperator == FilterOperatorType.ne && searchValue == 0) {
      return {
        and: [
          ODataFilterBuilder.buildSimpleFilter(this.targetField, null, FilterOperatorType.ne),
          {
            [this.targetField]: ODataFilterBuilder.buildNumberFilter(
              this.childFieldName,
              '0',
              FilterOperatorType.ne
            ),
          },
        ],
      };
    }

    if (filterOperator.actualOperator == FilterOperatorType.ne && searchValue != 0) {
      return {
        or: [
          ODataFilterBuilder.buildSimpleFilter(this.targetField, null),
          {
            [this.targetField]: ODataFilterBuilder.buildNumberFilter(
              this.childFieldName,
              searchValue,
              FilterOperatorType.ne
            ),
          },
        ],
      };
    }
    if (filterOperator.actualOperator == FilterOperatorType.ge && searchValue == 0) {
      return {
        or: [
          ODataFilterBuilder.buildSimpleFilter(this.targetField, null),
          {
            [this.targetField]: ODataFilterBuilder.buildNumberFilter(
              this.childFieldName,
              searchValue,
              FilterOperatorType.ge
            ),
          },
        ],
      };
    }
    if (
      filterOperator.actualOperator == FilterOperatorType.le ||
      filterOperator.actualOperator == FilterOperatorType.lt
    ) {
      return {
        or: [
          ODataFilterBuilder.buildSimpleFilter(this.targetField, null),
          {
            [this.targetField]: ODataFilterBuilder.buildNumberFilter(
              this.childFieldName,
              searchValue,
              filterOperator.actualOperator
            ),
          },
        ],
      };
    }

    return {
      [this.targetField]: ODataFilterBuilder.buildNumberFilter(
        this.childFieldName,
        searchValue,
        filterOperator.actualOperator
      ),
    };
  }
}
